<template>
    <div>
        <ConcernElementsSection
            v-if="hasSection('concern-elements')"
            :context="context"
            :settings="settings"
            @validity-change="handleConcernValidity"
            @action="$emit('action', $event)"
        />

        <ScipNumberSection
            v-if="showScipNumber"
            :value="scipNumber"
            :required="settings.scipNumberRequired === true"
            @input="handleScipNumberInput"
        />
    </div>
</template>

<script>
import { getNameOrId, ProductIdentifiers } from '@/libs/product'
import { isScipApplicable } from './scip-applicability'
import ConcernElementsSection from './sections/ConcernElementsSection.vue'
import ScipNumberSection from './sections/ScipNumberSection.vue'

export default {
    name: 'ComplianceInformationStep',
    components: {
        ConcernElementsSection,
        ScipNumberSection,
    },
    props: {
        context: { type: Object, required: true },
        settings: { type: Object, required: true },
        runtimeState: { type: Object, required: true },
    },
    data() {
        return {
            concernIsValid: !this.hasSection('concern-elements'),
        }
    },
    computed: {
        scipNumber() {
            return getNameOrId(
                (this.context.product && this.context.product.identifiers) || [],
                ProductIdentifiers.SCIP_NUMBER,
            ) || ''
        },
        showScipNumber() {
            return this.hasSection('scip-number') && isScipApplicable(this.context)
        },
        scipIsValid() {
            return !this.showScipNumber
                || this.settings.scipNumberRequired !== true
                || this.scipNumber.trim().length > 0
        },
    },
    watch: {
        showScipNumber: 'emitValidity',
        scipNumber: 'emitValidity',
        'settings.scipNumberRequired': 'emitValidity',
    },
    mounted() {
        this.emitValidity()
    },
    methods: {
        hasSection(section) {
            return Array.isArray(this.settings.sections) && this.settings.sections.includes(section)
        },
        handleConcernValidity(isValid) {
            this.concernIsValid = isValid === true
            this.emitValidity()
        },
        handleScipNumberInput(value) {
            this.$emit('action', {
                type: 'scip-number.change',
                payload: { value },
            })
        },
        emitValidity() {
            this.$emit('validity-change', {
                isValid: this.concernIsValid && this.scipIsValid,
                errors: [],
            })
        },
    },
}
</script>
